<button [id]="componentId + '-btn'" [attr.data-cy]="componentId + '-btn'" (click)="emitClick($event)"
  class="w-full rounded px-9 py-2 text-sm bg-white border border-blue-100 hover:bg-blue-100 hover:text-white"
  [disabled]="disableBtn"
  [ngClass]="{'text-white-disabled !border-white-disabled hover:text-white-disabled hover:!bg-white' : disableBtn}">
  {{btnText}} <ng-content></ng-content>
</button>
